(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu-pw"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pwMenuInit) return;
    window.__pwMenuInit = true;

    var FOCUSABLE = 'a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])';

    function lock() {
      var html = document.documentElement;
      var n = parseInt(html.dataset.pwLock || '0', 10) + 1;
      html.dataset.pwLock = n;
      if (n === 1) {
        html.dataset.pwLockPrev = html.style.overflow;
        html.style.overflow = 'hidden';
      }
    }

    function unlock() {
      var html = document.documentElement;
      var n = Math.max(0, parseInt(html.dataset.pwLock || '0', 10) - 1);
      html.dataset.pwLock = n;
      if (n === 0) {
        html.style.overflow = html.dataset.pwLockPrev || '';
        delete html.dataset.pwLockPrev;
      }
    }

    function resolve(target) {
      if (!target || !target.closest) return null;
      var root = target.closest('[data-pw-drawer]');
      var drawer = root ? (root.__pwDrawer || root.querySelector('.pw-drawer')) : target.closest('.pw-drawer');
      if (!drawer) return null;
      if (!root) root = drawer.__pwRoot;
      if (!root) return null;
      return { root: root, drawer: drawer, speed: parseInt(root.dataset.pwSpeed || '240', 10) };
    }

    /* The visible pane: the second level when open, otherwise the drawer itself. */
    function pane(drawer) {
      return drawer.querySelector('[data-pw-level2].is-open') || drawer.querySelector('.pw-drawer__panel');
    }

    function open(ctx) {
      var d = ctx.drawer;
      /* Drop drawers left in <body> by a block that has since been re-rendered. */
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el !== d && el.classList && el.classList.contains('pw-drawer')) {
          if (!el.__pwRoot || !el.__pwRoot.isConnected) el.remove();
        }
      });
      if (d.parentElement !== document.body) {
        d.__pwRoot = ctx.root;
        ctx.root.__pwDrawer = d;
        document.body.appendChild(d);
      }
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      lock();
      var toggle = ctx.root.querySelector('[data-pw-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var close = d.querySelector('[data-pw-close]:not(.pw-drawer__overlay)');
      if (close) close.focus({ preventScroll: true });
    }

    function close(ctx) {
      var d = ctx.drawer;
      if (!d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      unlock();
      var toggle = ctx.root.querySelector('[data-pw-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus({ preventScroll: true });
      }
      setTimeout(function () {
        d.hidden = true;
        d.querySelectorAll('[data-pw-level2]').forEach(function (p) {
          p.hidden = true;
          p.classList.remove('is-open', 'is-closing');
        });
        /* Put it back where Liquid rendered it, so a re-render replaces it cleanly. */
        if (ctx.root.isConnected) ctx.root.appendChild(d);
      }, ctx.speed);
    }

    function drill(ctx, index) {
      var panel = ctx.drawer.querySelector('[data-pw-level2="' + index + '"]');
      if (!panel) return;
      panel.hidden = false;
      panel.classList.remove('is-closing');
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      setTimeout(function () {
        var back = panel.querySelector('[data-pw-back]');
        if (back) back.focus({ preventScroll: true });
      }, 40);
    }

    function back(ctx) {
      var panel = ctx.drawer.querySelector('[data-pw-level2].is-open');
      if (!panel) return false;
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      setTimeout(function () {
        panel.hidden = true;
        panel.classList.remove('is-closing');
      }, ctx.speed);
      var tile = ctx.drawer.querySelector('[data-pw-drill="' + panel.dataset.pwLevel2 + '"]');
      if (tile) tile.focus({ preventScroll: true });
      return true;
    }

    document.addEventListener('click', function (event) {
      var ctx = resolve(event.target);
      if (!ctx) return;

      if (event.target.closest('[data-pw-open]')) return open(ctx);
      if (event.target.closest('[data-pw-close]')) return close(ctx);

      var trigger = event.target.closest('[data-pw-drill]');
      if (trigger) return drill(ctx, trigger.dataset.pwDrill);
      if (event.target.closest('[data-pw-back]')) { back(ctx); return; }

      var search = event.target.closest('[data-pw-search]');
      if (search) {
        var selector = ctx.root.dataset.pwSearchSelector;
        var button = selector ? document.querySelector(selector) : null;
        if (button) {
          event.preventDefault();
          close(ctx);
          setTimeout(function () { button.click(); }, ctx.speed + 20);
        }
        return;
      }

      var head = event.target.closest('.pw-acc__head');
      if (head) {
        var body = head.nextElementSibling;
        var expanded = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.hidden = expanded;
      }
    });

    document.addEventListener('keydown', function (event) {
      var drawer = document.querySelector('.pw-drawer.is-open');
      if (!drawer) return;
      var ctx = resolve(drawer);
      if (!ctx) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        if (!back(ctx)) close(ctx);
        return;
      }

      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(pane(drawer).querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!pane(drawer).contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pwMenuInit) return;
    window.__pwMenuInit = true;

    var FOCUSABLE = 'a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])';

    function lock() {
      var html = document.documentElement;
      var n = parseInt(html.dataset.pwLock || '0', 10) + 1;
      html.dataset.pwLock = n;
      if (n === 1) {
        html.dataset.pwLockPrev = html.style.overflow;
        html.style.overflow = 'hidden';
      }
    }

    function unlock() {
      var html = document.documentElement;
      var n = Math.max(0, parseInt(html.dataset.pwLock || '0', 10) - 1);
      html.dataset.pwLock = n;
      if (n === 0) {
        html.style.overflow = html.dataset.pwLockPrev || '';
        delete html.dataset.pwLockPrev;
      }
    }

    function resolve(target) {
      if (!target || !target.closest) return null;
      var root = target.closest('[data-pw-drawer]');
      var drawer = root ? (root.__pwDrawer || root.querySelector('.pw-drawer')) : target.closest('.pw-drawer');
      if (!drawer) return null;
      if (!root) root = drawer.__pwRoot;
      if (!root) return null;
      return { root: root, drawer: drawer, speed: parseInt(root.dataset.pwSpeed || '240', 10) };
    }

    /* The visible pane: the second level when open, otherwise the drawer itself. */
    function pane(drawer) {
      return drawer.querySelector('[data-pw-level2].is-open') || drawer.querySelector('.pw-drawer__panel');
    }

    function open(ctx) {
      var d = ctx.drawer;
      /* Drop drawers left in <body> by a block that has since been re-rendered. */
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el !== d && el.classList && el.classList.contains('pw-drawer')) {
          if (!el.__pwRoot || !el.__pwRoot.isConnected) el.remove();
        }
      });
      if (d.parentElement !== document.body) {
        d.__pwRoot = ctx.root;
        ctx.root.__pwDrawer = d;
        document.body.appendChild(d);
      }
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      lock();
      var toggle = ctx.root.querySelector('[data-pw-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var close = d.querySelector('[data-pw-close]:not(.pw-drawer__overlay)');
      if (close) close.focus({ preventScroll: true });
    }

    function close(ctx) {
      var d = ctx.drawer;
      if (!d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      unlock();
      var toggle = ctx.root.querySelector('[data-pw-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus({ preventScroll: true });
      }
      setTimeout(function () {
        d.hidden = true;
        d.querySelectorAll('[data-pw-level2]').forEach(function (p) {
          p.hidden = true;
          p.classList.remove('is-open', 'is-closing');
        });
        /* Put it back where Liquid rendered it, so a re-render replaces it cleanly. */
        if (ctx.root.isConnected) ctx.root.appendChild(d);
      }, ctx.speed);
    }

    function drill(ctx, index) {
      var panel = ctx.drawer.querySelector('[data-pw-level2="' + index + '"]');
      if (!panel) return;
      panel.hidden = false;
      panel.classList.remove('is-closing');
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      setTimeout(function () {
        var back = panel.querySelector('[data-pw-back]');
        if (back) back.focus({ preventScroll: true });
      }, 40);
    }

    function back(ctx) {
      var panel = ctx.drawer.querySelector('[data-pw-level2].is-open');
      if (!panel) return false;
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      setTimeout(function () {
        panel.hidden = true;
        panel.classList.remove('is-closing');
      }, ctx.speed);
      var tile = ctx.drawer.querySelector('[data-pw-drill="' + panel.dataset.pwLevel2 + '"]');
      if (tile) tile.focus({ preventScroll: true });
      return true;
    }

    document.addEventListener('click', function (event) {
      var ctx = resolve(event.target);
      if (!ctx) return;

      if (event.target.closest('[data-pw-open]')) return open(ctx);
      if (event.target.closest('[data-pw-close]')) return close(ctx);

      var trigger = event.target.closest('[data-pw-drill]');
      if (trigger) return drill(ctx, trigger.dataset.pwDrill);
      if (event.target.closest('[data-pw-back]')) { back(ctx); return; }

      var search = event.target.closest('[data-pw-search]');
      if (search) {
        var selector = ctx.root.dataset.pwSearchSelector;
        var button = selector ? document.querySelector(selector) : null;
        if (button) {
          event.preventDefault();
          close(ctx);
          setTimeout(function () { button.click(); }, ctx.speed + 20);
        }
        return;
      }

      var head = event.target.closest('.pw-acc__head');
      if (head) {
        var body = head.nextElementSibling;
        var expanded = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.hidden = expanded;
      }
    });

    document.addEventListener('keydown', function (event) {
      var drawer = document.querySelector('.pw-drawer.is-open');
      if (!drawer) return;
      var ctx = resolve(drawer);
      if (!ctx) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        if (!back(ctx)) close(ctx);
        return;
      }

      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(pane(drawer).querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!pane(drawer).contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
